import { type Enum } from '@webapp/infrastructure/types/Enum'

/** The backend sends these when it rejects an order's entity, an item vendor outside it, or an entity change after submit. */
export const LegalEntityErrorCodes = {
  LEGAL_ENTITY_REQUIRED: 'ORDER_LEGAL_ENTITY_REQUIRED',
  LEGAL_ENTITY_INACTIVE: 'ORDER_LEGAL_ENTITY_INACTIVE',
  LEGAL_ENTITY_NOT_ASSIGNED_TO_REQUESTER:
    'ORDER_LEGAL_ENTITY_NOT_ASSIGNED_TO_REQUESTER',
  VENDOR_NOT_AVAILABLE_FOR_LEGAL_ENTITY:
    'ORDER_ITEM_VENDOR_NOT_AVAILABLE_FOR_LEGAL_ENTITY',
  LEGAL_ENTITY_CHANGE_NOT_ALLOWED: 'ORDER_LEGAL_ENTITY_CHANGE_NOT_ALLOWED',
} as const

export type LegalEntityErrorCodeEnum = Enum<typeof LegalEntityErrorCodes>

const LEGAL_ENTITY_ERROR_CODE_VALUES: ReadonlySet<string> = new Set(
  Object.values(LegalEntityErrorCodes)
)

export const isLegalEntityErrorCode = (
  code: string
): code is LegalEntityErrorCodeEnum => LEGAL_ENTITY_ERROR_CODE_VALUES.has(code)

/**
 * The backend derives the entity from the secondary category, the only entity
 * input a request carries, so it reports these codes on `department`.
 */
export const DERIVED_LEGAL_ENTITY_ERROR_CODES: ReadonlySet<string> = new Set([
  LegalEntityErrorCodes.LEGAL_ENTITY_REQUIRED,
  LegalEntityErrorCodes.LEGAL_ENTITY_INACTIVE,
  LegalEntityErrorCodes.LEGAL_ENTITY_NOT_ASSIGNED_TO_REQUESTER,
])

export const isDerivedLegalEntityErrorCode = (code: string): boolean =>
  DERIVED_LEGAL_ENTITY_ERROR_CODES.has(code)
